<template>
<!--Carl Cannon\'s Great American Stories-->
<div class="col american-stories">
    <h3 class="section-heading">Carl Cannon's Great American Stories</h3>
    <ul class="items">
        <template v-for="(post, i) in section.posts" >
            <li class="item" :key="post.id" v-if="(i + 1) <= section.item_limit">
                <div class="item-title">
                    <a :href="post.permalink" :target="hrefTarget">{{post.title}}</a>
                </div>
                <div class="excerpt" v-html="post.body_text"></div>
            </li>
        </template>
    </ul>
    <div class="load-more" @click="openCarlCannonsAuthorPage()">Archive</div>
    <!-- <div v-if="section.item_limit < section.posts.length" 
        class="load-more" @click="displayMorePostsForSection(section)">Load More</div> -->
</div><!-- End of Carl Cannon\'s Great American Stories -->
</template>

<script>

import SectionsMixin from './SectionsMixin.js';

export default {
    name: 'american-stories',
    mixins: [
        SectionsMixin,
    ],
}
</script>